import LinkButton from '@sats-group/ui-lib/react/link-button';
import Text from '@sats-group/ui-lib/react/text';
import React from 'react';
import { Logo } from '~/source/ui/logo/logo';
import { SplashLayout } from '~/source/ui/splash-layout/splash-layout';
import type { Welcome as Props } from './welcome.page.types';

export const Welcome: React.FC<Props> = ({ action, text }) => (
  <SplashLayout>
    <div className="welcome">
      <div className="welcome__container">
        <div className="welcome__card">
          <div className="welcome__content">
            <Logo elementName="h1" variant="dark" />
            {text.map(entry => (
              <Text elementName="p" key={entry} tight>
                {entry}
              </Text>
            ))}
            <div>
              <LinkButton
                {...action}
                size={LinkButton.sizes.basic}
                variant={LinkButton.variants.complete}
                wide
              />
            </div>
          </div>
          <div className="welcome__decoration" />
        </div>
      </div>
    </div>
  </SplashLayout>
);
